import type { MemberKind } from '@/api/chat/v2-types';

import type { ContextKind, KindFilter, StateFilter } from './types';

export const DISCLOSURE = {
  threadCountForFullShell: 10,
} as const;

export interface DisclosureInput {
  threadCount: number;
  topicCount: number;
  hasDeskIdentity: boolean;
}

export const shouldShowFullShell = ({
  threadCount,
  topicCount,
  hasDeskIdentity,
}: DisclosureInput): boolean =>
  hasDeskIdentity || topicCount > 0 || threadCount >= DISCLOSURE.threadCountForFullShell;

export const STATE_FILTER_LABELS: Record<StateFilter, string> = {
  needsAction: 'Needs action',
  unread: 'Unread',
  awaitingReply: 'Awaiting reply',
  waiting: 'Waiting',
  muted: 'Muted',
};

export const KIND_FILTER_LABELS: Record<KindFilter, string> = {
  all: 'All',
  contact: 'Contacts',
  topic: 'Topics',
  broadcast: 'Broadcasts',
  groupChat: 'Group chats',
};

export const CONTEXT_KIND_LABELS: Record<ContextKind, string> = {
  contact: 'Contact',
  topic: 'Topic',
  broadcast: 'Broadcast',
  groupChat: 'Group chat',
};

export const MEMBER_KIND_LABELS: Record<MemberKind, string> = {
  follower: 'Following',
  investor: 'Invested',
  ticket_holder: 'Ticket holder',
};

export const MAX_KIND_CHIPS = 5;

export const LOCKED_TOPIC_LABEL = 'Locked topic';
export const LOCKED_TOPIC_REASON = "You don't have access to this topic.";
export const SYSTEM_TOPIC_NOTE =
  "Filed automatically by who the conversation is with and what it is about: an inquiry, a fund, a deal, an event or a support request. It can't be renamed or archived.";
export const LOCKED_TOPIC_VISIBILITY_REASON = 'You can only change who sees a topic you can open.';
export const CREATOR_ROLE_REASON = 'You always see topics you create';
export const TOPIC_NAME_RESERVED_REASON = 'This name is reserved for a system topic.';
export const TOPIC_REQUIRED_REASON = 'A conversation needs at least one topic you can open.';
export const TOPIC_TOGGLE_LOCKED_REASON =
  'That topic is locked for you. Ask a roles admin for access.';
export const CONVERSATION_TOPIC_LOCKED_REASON =
  "You can't start this conversation: it would be filed under a topic your role can't open. Ask a roles admin for access.";
export const PARTICIPANTS_TOPIC_LOCKED_REASON =
  "You can't add them: the conversation would be filed under a topic your role can't open. Ask a roles admin for access.";
export const NEW_THREAD_BLOCKED_REASON = 'You do not have permission to start a thread.';
export const RECIPIENT_NOT_IN_DIRECTORY_REASON = 'That recipient is not in your directory.';
export const SELF_RECIPIENT_REASON = "You can't start a conversation with yourself.";
